var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-6 w-full"},[_c('img',{staticClass:"mx-auto",attrs:{"src":require("@/assets/images/icons/svg/tilde.svg")}})])
}]

export { render, staticRenderFns }